import RouteHashScroll from './routeHashScroll'

export default RouteHashScroll
